interface Props {
    className?: string
    pathClassName?: string
    FillColor?: string
}

export default function BurgerMenu({
                                       className = '',
                                       pathClassName = '',
                                       FillColor = 'black'
                                   }:Props) {
    return (
        <svg className={className}
             width="24"
             height="24"
             viewBox="0 0 24 24">
            <path
                d="M3.30652 8.35163C3.17831 8.22384 3.17831 8.01357 3.30652 7.88578C3.82259 7.37141 4.65998 7.37141 5.17605 7.88578C6.06283 8.76966 11.8783 14.5819 11.8783 14.5819C11.8783 14.5819 17.4421 9.09844 18.6587 7.88578C19.1748 7.37141 20.0122 7.37141 20.5282 7.88578C20.6564 8.01357 20.6581 8.22223 20.5282 8.35163L12.8521 16.0026C12.3361 16.5169 11.4987 16.5169 10.9826 16.0026L3.30652 8.35163Z"
                fill={FillColor}
            />
        </svg>
    )
}
